import type { MainInjector } from '@/di/injector';

import { PermissionsRouteGuard } from './use-cases/route-guard';

export function installPermissionsRouteGuard(injector: MainInjector) {
    const routeGuard = injector.injectClass(PermissionsRouteGuard);
    routeGuard.install();
}
